import { NavLink } from '../../types/nav-link'

export function nationalExperiencePageToNavLink(item: any): NavLink {
  return {
    label: item.title,
    url: `/experience/${item.sys.id}/${item.slug}`,
  }
}
